const range = (start: number, stop: number, step = 1) =>
  Array.from({ length: Math.abs(stop - start) / Math.abs(step) + 1 }, (_, i) => start + i * step);

export default range;
